import { cn } from '@/lib/utils';

/**
 * Logo Super. Le fichier est un PNG large (utilisable en grand sur l'écran de
 * connexion) ; on le contraint par la hauteur pour qu'il reste net sur l'écran
 * Retina de l'iPad.
 */
export default function Logo({ className }: { className?: string }) {
  return <img src="/logo-super.png" alt="Super" className={cn('h-auto w-auto', className)} />;
}
